export const Chefs = () => {
    return (
        <main>
            <h2>CHEFS PAGE</h2>
        </main>
    )
}